module.exports = __webpack_public_path__ + "img/dckap-logo.5b1d8383.svg";